import classes from "./ProductItem.module.less";
import { saveSearchTerm } from "~/features/search/api/saveSearchTerm";
import type { SrpProductData } from "~/utils/models";
import { forwardRef } from "react";
import { ProductContext } from "~/domains/product/ProductContext";
import { Product } from "~/domains/product/Product";
import { SaleTag } from "~/domains/salesCampaign/components/SaleTag/SaleTag";
import { LinkType } from "~/common/components/Link";
import { useIsMinDesktopSizeM } from "~/common/hooks/useMediaQuery";

interface Props {
  className?: string;
  product: SrpProductData;
}

export function resolveProductUrlAutosuggest(product: SrpProductData) {
  const baseUrl = window.location.origin + window.SCHA.urls.contextPath + product.url;
  const url = new URL(baseUrl);
  url?.searchParams?.set("text", product.designation);
  const finalUrl = url?.toString() ?? "";

  return finalUrl;
}

export const ProductItem = forwardRef<HTMLAnchorElement, Props>(({ product, className }: Props, ref) => {
  const hasSales = Object.keys(product.salesCampaign).length > 0;

  const pdpUrl = resolveProductUrlAutosuggest(product);

  const linkProps = {
    onClick: () => saveSearchTerm(product.designation, pdpUrl),
    href: pdpUrl,
    ["tracking-aux-sch-prod-name"]: product.designation,
    ["tracking-aux-sch-prod-id"]: product.sapMaterialNumber,
    ["data-prod-article"]: product.hybrisCode,
  };

  const isDesktopM = useIsMinDesktopSizeM();

  return (
    <ProductContext value={product}>
      <div
        className={classes.root}
        asgsta-product-parent-marker="true"
        asgsta-is-campaign-belonging={`${hasSales}`}
        asgsta-campaign={Object.values(product.salesCampaign)[0]?.[0].code ?? "None"}
        data-zoovu="searchSuggestion"
      >
        {isDesktopM && <Product.PrimaryImage className={classes.image} linkProps={{ ...linkProps, tabIndex: -1 }} />}
        <div className={classes.designationContainer}>
          <Product.FullDesignation
            designationComponent={"span"}
            linkProps={{ ...linkProps, ref, variant: LinkType.NAVIGATION }}
          />
          {hasSales && <SaleTag size={16} />}
        </div>
        <Product.ShortDescription className={classes.description} linkProps={{ ...linkProps, tabIndex: -1 }} />
      </div>
    </ProductContext>
  );
});
